import React from "react";
import { RiNotification2Fill } from "react-icons/ri";
import "./styles.scss"

export const PageName = ({ icon, name }) => {
  return (
    <div className="page-name">
      <div className="page-name__icon">{icon}</div>
      <div className="page-name__title">
        <h1>{name}</h1>
      </div>
    </div>
  )
}
